module.exports = __webpack_public_path__ + "img/symbol_8.837c4067.png";